// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mnrurlwbjpmltmucwieo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1ucnVybHdianBtbHRtdWN3aWVvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEyMTU5MDIsImV4cCI6MjA1Njc5MTkwMn0.3TcPDMrvHWh9Xp_klpVl6R9Ew3kwoiQ80Tp3ltycI4w";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);